import React, { useState } from "react";
import { useGetAccommodationConfirmationByIdQuery } from "@graphql";
import { ErrorCard, Spinner } from "@common";

import { AccommodationConfirmationStore } from "./AccommodationConfirmationStore";
import { AccommodationConfirmationForm } from "./AccommodationConfirmationForm";
import { AccommodationConfirmationFormData, mapDataToValues } from "./utils";

type Props = {
  bookingId: string;
  confirmationId: string;
};

export const AccommodationConfirmationViewPage = (props: Props) => {
  const [formStore, setFormStore] = useState<AccommodationConfirmationStore>(null);

  const { loading, error } = useGetAccommodationConfirmationByIdQuery({
    variables: { bookingId: props.bookingId, confirmationId: props.confirmationId },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const initialValues: AccommodationConfirmationFormData = mapDataToValues(data);
      const store = new AccommodationConfirmationStore(
        props.confirmationId,
        props.bookingId,
        data.bookingById,
        initialValues,
        []
      );
      setFormStore(store);
    }
  });

  if (!formStore || loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorCard title="Cannot load item" message={error.message} />;
  }

  return <AccommodationConfirmationForm isNew={false} formStore={formStore} />;
};
